import * as React from 'react';
import * as AdaptiveCards from 'adaptivecards';
import 'adaptivecards/lib/adaptivecards.css';

export interface AdaptiveCardProps {
  payload: any;
  style?: React.CSSProperties;
  className?: string;
}

interface AdaptiveCardState {
  error?: string;
}

// Compatibility wrapper: preserves the existing "adaptivecards-react" API used by the app
// while delegating rendering to the official Adaptive Cards renderer package.
export class AdaptiveCard extends React.Component<AdaptiveCardProps, AdaptiveCardState> {
  private containerRef = React.createRef<HTMLDivElement>();

  constructor(props: AdaptiveCardProps) {
    super(props);
    this.state = {};
  }

  public componentDidMount(): void {
    this.renderCard();
  }

  public componentDidUpdate(prevProps: AdaptiveCardProps): void {
    if (prevProps.payload !== this.props.payload) {
      this.renderCard();
    }
  }

  private renderCard(): void {
    const container = this.containerRef.current;

    if (!container) {
      return;
    }

    container.innerHTML = '';

    if (!this.props.payload || typeof this.props.payload !== 'object') {
      this.setState({ error: 'Invalid Adaptive Card payload.' });
      return;
    }

    try {
      const card = new AdaptiveCards.AdaptiveCard();
      card.parse(this.props.payload);

      const renderedCard = card.render();

      if (!renderedCard) {
        this.setState({ error: 'Adaptive Card renderer returned an empty result.' });
        return;
      }

      container.appendChild(renderedCard);
      this.setState({ error: undefined });
    } catch (error) {
      console.error('Adaptive Card render failed', error);
      this.setState({ error: 'Failed to render Adaptive Card.' });
    }
  }

  public render(): JSX.Element {
    return (
      <div className={this.props.className} style={this.props.style}>
        <div ref={this.containerRef} />
        {this.state.error && (
          <div style={{ color: '#c50f1f', fontSize: 12, marginTop: 8 }}>
            {this.state.error}
          </div>
        )}
      </div>
    );
  }
}
